<template>
  <div class="semester_Score">
    <Header title="各类课表查询(分时间段)"></Header>
    <div class="contextDiv" >
      <div style="padding-left:10px;padding-right:5px;height: 20px;line-height: 20px;">
        {{$route.query.dateTime}}{{$route.query.jcMsg}}<span style="font-size: 12px;color: red;float: right;">有{{semesterData.length}}个教室上课</span>
      </div>
      <div class="item">
        <el-table :data="semesterData" @cell-click="handle"
        height="82vh"
       tooltip-effect="dark"
       :header-cell-style="{'border':'1px solid','border-color':'#EBEEF5','text-align': 'center','background-color':'rgba(143,135,249,.8)'}"
       :cell-style="{'border':'1px solid','border-color':'#EBEEF5','text-align': 'center','white-space':'nowrap'}"
       style="width:100%;border:1px solid;border-color:#EBEEF5"
      >
        <el-table-column prop="classroom" label="上课教室"  ></el-table-column>
      	<el-table-column prop="teachername" label="授课老师"></el-table-column>
        <el-table-column prop="coursename" label="课程名称" width="160" ></el-table-column>
      </el-table>
      </div>
    </div>
    <van-popup v-model="popShow" class="popup" style="width:280px;height: auto;">
      <h2>{{this.item_kb.coursename}}</h2>
      <p>课程编号：<span>{{this.item_kb.coursenumber}}</span></p>
      <p>上课学院：<span>{{this.item_kb.skxy}}</span></p>
      <p>授课老师：<span>{{this.item_kb.teachername}}</span></p>
      <p>上课教室：<span>{{this.item_kb.classroom}}</span></p>
      <p>上课班级：<span>{{this.item_kb.ktmc}}</span></p>
      <p>上课时间：<span>{{this.item_kb.jctime}}</span></p>
      <button @click="popShow=false">确定</button>
    </van-popup>
    
  </div>
</template>
<script>
import { Api } from "@/utils/axios";
export default {
  data() {
    return {
      type: this.$route.query.findType,
      semesterData:[],
      popShow:false,
      currenPage:1,
      item_kb:{},
    };
  },
  created() {
    this.initData();
  },  
  methods: {
    //初始化数据
    async initData(){
      const params = {
          xnxq:this.$route.query.xnxq,
          kbsjmsid:this.$route.query.kbsjmsid,
          jcName:this.$route.query.jcName,
          dateTime:this.$route.query.dateTime,
        }
        
       const res = await Api.initKbData_time(params);
       if(res.code=='1'){
        this.semesterData = res.data;
       }
    },
    handle(index){
      this.item_kb = index;
      this.popShow = true;
    }
  }
};
</script>
<style scoped lang="less">
  .page {
    position: fixed;
    bottom: 1.25rem;
    padding: 0 1.25rem;
    width: 100%;
    left: 0;
    box-sizing: border-box;
    z-index: 3000;
  }
  .contextDiv{
    overflow: auto;
    height: 90vh;
    margin-bottom: 10px;
    .item {
      border-radius: 5px;
      padding: 3px 3px 3px 3px;
      box-sizing: border-box;
    }
  }

  .van-popup.van-popup--center{box-sizing: border-box;padding: 20px;}
  .semester_Score .van-popup.van-popup--center>h2{color: @attendance-color-1;font-size: 16px;line-height: 25px;text-align: center;font-weight: bold;}
  .van-popup.van-popup--center>div{color: @attendance-background-color-1;font-size: 24px;font-weight: bold;text-align: center;padding-top: 10px;padding-bottom: 10px;}
  .van-popup.van-popup--center>p{color: @attendance-color-2;font-size: 16px;line-height: 30px;}
  .van-popup.van-popup--center>p>span{font-weight: bold;font-size: 14px}
  .popup button{background-color: @attendance-background-color-7;color: @attendance-background-color-1;padding: 11px 0;border-radius: 3px;width: 100%;margin-top: 30px;}
  .van-popup.van-popup--bottom{border-radius: 5px 5px 0 0;}
  .van-pagination__item--active{
    background-color: rgba(143,135,249,1);
  }

  .van-pagination__item{
    color: rgba(143,135,249,1);
    background-color: rgba(143,135,249,1);
  }
  
</style>

<style  lang="less">
.el-table .cell{
    white-space: nowrap;
  }
</style>


// WEBPACK FOOTER //
// src/components/teacher/teachCuseAll/surfacesAll_time.vue